import { Component, OnInit } from '@angular/core';
import { CurrentLoginStylingService } from '@modules/common/services/current-login-styling.service';
import { LoginMainImageUrlService } from '@modules/common/services/login-main-image-url.service';

@Component({
    selector: 'app-login-layout-main-img',
    templateUrl: './login-layout-main-img.component.html',
    styleUrls: ['./login-layout-main-img.component.scss']
})
export class LoginLayoutMainImgComponent implements OnInit {
    public mainImage: string = '';
    private static MAIN_IMAGE_URL: string = 'https://media.winstonfinancial.com/Stingray/Images/HRally_Login_BGbug.png';

    constructor(
        private _currentLoginStylingService: CurrentLoginStylingService,
        private _loginMainImageUrlService: LoginMainImageUrlService
    ) { }

    public ngOnInit(): void {
        this._currentLoginStylingService.configChanged.subscribe(result => {
            if (result && result.mainImageVersion) {
                this.mainImage = this._loginMainImageUrlService.getUrl(result.mainImageVersion);
            } else {
                this.mainImage = LoginLayoutMainImgComponent.MAIN_IMAGE_URL;
            }
        });
    }
}
